import React from 'react';
import { Link } from 'react-router-dom';
import { t } from '@sm/intl';
import COPY from './copy';

export default function IncludedLink(): React.ReactElement {
  return <Link to="/pricing/teams/details">{t(COPY.BUSINESS_PLANS_LINK)}</Link>;
}
